import { render, staticRenderFns } from "./WorkReport.vue?vue&type=template&id=1ae56420&scoped=true"
import script from "./WorkReport.vue?vue&type=script&lang=js"
export * from "./WorkReport.vue?vue&type=script&lang=js"
import style0 from "./WorkReport.vue?vue&type=style&index=0&id=1ae56420&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae56420",
  null
  
)

/* custom blocks */
import block0 from "./resources/locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fgithub%2Fworkspace%2Fsrc%2Fviews%2Freports%2Fwork-report%2FWorkReport.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports